import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ReportTable from "../common/ReportTable";
//import header from "../../assets/images/registrationHeader.png";
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Copyright from '../common/copyright';
import Header from "../common/header";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TestReportBtn from "../../assets/images/test-report-btn.png";
import CircularStatic from '../common/CircularProgressWithLabel';
import { Grid, Button } from "@material-ui/core";
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { useHistory, useLocation, Redirect, Route } from "react-router-dom";


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: 'column',
        minHeight: '100vh',
    },
    table: {
        maxWidth: '80%',
        margin: 'auto'
    },
    tableDifficulty: {
        maxWidth: '0%',
        margin: 'auto'
    },
    tableHeading: {
        backgroundColor: "#F05A29",
        borderRight: "1px solid #fbae3f",
        borderLeft: "1px solid #fbae3f",
        borderBottom: "1px solid #fbae3f",
        borderTop: "1px solid #fbae3f"
    },
    tableCell: {
        borderRight: "1px solid #fbae3f",
        borderLeft: "1px solid #fbae3f",
        borderBottom: "1px solid #fbae3f",
        borderTop: "1px solid #fbae3f"
    },
    tableContainer: {
        maxHeight: 400,
        boxShadow: 'none',
        marginBottom: '15px'
    },
    reportContainer: {
        //marginTop: '200px'
        marginTop: '25px'
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        // backgroundColor:
        //     theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
    },
    difficultyText: {
        fontSize: '20px',
        color: 'green',
        fontWeight: '600'
    },
    starIcon: {
        color: 'gold',
        fontSize: '30px'
    },
    // reportButton: {
    //     marginTop: '20px'
    // },
    difficultyContainer: {
        boxShadow: 'none',
        // marginBottom: '20px'
    },
    tableCellDifficulty: {
        borderBottom: '0px'
    },
    starColumn: {
        marginBottom: '15px'
    }
}));

export default function AssessmentSummary() {

    const location = useLocation()
    const history = useHistory()

    // const [name, setName] = useState('')
    // const [stateName, setStateName] = useState('')
    
    // console.log("location", location.state);
    let percentage;
    let totalStars
    if (location.state !== undefined) {
        percentage = ((location.state.testData.correctQuesionCnt / location.state.testData.totalQuesionCnt) * 100)
        totalStars = location.state.testData.countOfStar
    }
    var name = ''
    var stateName = ''
    if(location.state != undefined && location.state.studentDetails != undefined){
        // setName(location.state.studentDetails.name)
        // setStateName(location.state.studentDetails.stateName)
        name = location.state.studentDetails.name
        stateName = location.state.studentDetails.stateName
    }
    const classes = useStyles();

    function numberOfStars() {
        const numberOfStars = []
        for (var i = 0; i < totalStars; i++) {
            numberOfStars.push(
                <StarBorderIcon className={classes.starIcon}></StarBorderIcon>
            )
        }
        return numberOfStars
    }

    function navigateToDetail() {
        history.push({
            pathname: "/detailedReport",
            // search: "?query=abc",
            state: {
                assessmentDetails: location.state.assessmentDetails,
                studentDetails: location.state.studentDetails,
                testData: location.state.testData,
                responseArray: location.state.responseArray,
                correctAnswerArray: location.state.correctAnswerArray,
                seconds: location.state.seconds
            },
        });
    }

    return (
        <Route
            {...location.state}
            render={item =>
                (location.state !== undefined) ? (
                    <div className={classes.root}>
                        <Header
                            name={name}
                            location={stateName}
                            className={location.state.assessmentDetails.className}
                        ></Header>
                        <Container component="main" maxWidth="xl" className={classes.reportContainer}>
                            <TableContainer component={Paper} className={classes.difficultyContainer}>
                                <Table className={classes.tableDifficulty} size="small" aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" scope="row" className={classes.tableCellDifficulty}>
                                                <Typography alignItems="right" className={classes.difficultyText}>{location.state.level}</Typography>
                                            </TableCell>

                                            <TableCell component="th" scope="row" className={classes.tableCellDifficulty}>
                                                <CircularStatic percentage={percentage} />
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>


                            <Typography align="center" className={classes.starColumn}>
                                {numberOfStars()}
                            </Typography>

                            <TableContainer component={Paper} className={classes.tableContainer}>
                                <Table className={classes.table} size="small" stickyHeader aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHeading}>Lesson Name</TableCell>
                                            <TableCell className={classes.tableHeading} align="right">{location.state.assessmentDetails.name}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        <TableRow >
                                            <TableCell
                                                className={classes.tableCell}
                                                component="th"
                                                scope="row"
                                            >
                                                Total Questions
                                </TableCell>
                                            <TableCell className={classes.tableCell} align="right">
                                                {location.state.testData.totalQuesionCnt}
                                            </TableCell>
                                        </TableRow>

                                        <TableRow >
                                            <TableCell
                                                className={classes.tableCell}
                                                component="th"
                                                scope="row"
                                            >
                                                Correct Answer
                                </TableCell>
                                            <TableCell className={classes.tableCell} align="right">
                                                {location.state.testData.correctQuesionCnt}
                                            </TableCell>
                                        </TableRow>

                                        <TableRow >
                                            <TableCell
                                                className={classes.tableCell}
                                                component="th"
                                                scope="row"
                                            >
                                                Wrong Answer
                                </TableCell>
                                            <TableCell className={classes.tableCell} align="right">
                                                {location.state.testData.totalQuesionCnt - location.state.testData.correctQuesionCnt}
                                            </TableCell>
                                        </TableRow>


                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <SubmitButton
                                onClick={() => navigateToDetail()}
                            />
                        </Container>
                        <footer className={classes.footer}>
                            <Container maxWidth="sm">
                                <Copyright />
                            </Container>
                        </footer>
                    </div>
                ) :
                    (
                        <Redirect to={{ pathname: '/' }} />
                    )
            }
        />
    );



    function SubmitButton({ onClick }) {
        const styles = useStyles()
        function MiddleAlign() {
            return (
                <Grid container spacing={1}>
                    <Grid item container
                        direction="row"
                        justify="center"
                        alignItems="center">
                        <Button
                            type="submit"
                            variant="text"
                            className={styles.submit}
                            onClick={onClick}
                        >
                            <img className="submitImage" src={TestReportBtn} alt="start" />
                        </Button>
                    </Grid>
                </Grid>
            );
        }
        return (
            <div >
                <Grid container spacing={1}>
                    <Grid container item xs={12}>
                        <MiddleAlign />
                    </Grid>
                </Grid>
            </div>
        )
    }
}


